import { Rout_create } from './Rout.create'
import { Rout_to } from './Rout'

export interface Rout_SmartDataRoutesArgs {
    SD_ViewSmartData: React.FunctionComponent<unknown>
}

export const Rout_SmartDataRoutes = (args: Rout_SmartDataRoutesArgs) => [
    Rout_create('/smartdata/viewSmartData/location/:locationId(/unit/:unitId)', args.SD_ViewSmartData),
]

export function Rout_toSmartDataLocation(locationId: number) {
    Rout_to(`/smartdata/viewSmartData/location/${locationId}`)
}

export function Rout_toSmartDataUnit(locationId: number, unitId: number) {
    Rout_to(`/smartdata/viewSmartData/location/${locationId}/unit/${unitId}`)
}
